<template>
  <div v-if="currentQuestion" class="mb-8">
    <HTTPresponse :alert="httpalert" @changeHTTPBoxState="HTTPState"></HTTPresponse>
    <div class="box-outlined">
      <v-layout
        d-flex
        row
        ma-0
        align-center
        justify-space-between
        class="box-header"
      >
        <v-flex xs12 sm7 lg8>
          <h2
            class="box-header-item mb-3 mb-md-0"
            v-html="currentQuestion.info[`title_${$i18n.locale}`]"
          ></h2>
        </v-flex>
        <v-divider vertical inset></v-divider>
        <v-flex xs12 sm3 lg2>
          <p class="box-header-item ma-0 text-center d-flex align-center">
            <span class="h2 mr-1" v-html="currentQuestion.done.point"></span>
            <strong>{{ $tc("survey-question-block.point",
                           parseInt(currentQuestion.done.point) == 1 ||
                           parseInt(currentQuestion.done.point) == 0 ?
                           1 : parseInt(currentQuestion.done.point)) }}</strong>
          </p>
        </v-flex>
      </v-layout>

      <div class="box-content pa-0">
        <!-- check if modules is not empty -->
        <template v-if="rebuildInputs && rebuildInputs.length > 0">
          <v-layout
            v-for="input in rebuildInputs"
            :key="input.id"
            class="box-content-item"
            d-block
            d-md-flex
            row
            ma-0
            align-center
            justify-space-between
            xs12
            lg10
            :style="{ background: input.bg||input[0].bg }"
          >
            <template>
              <v-flex
                xs12
                lg10
                offset-lg2
                style="position: relative;"
              >
                <Inputs
                  :answerid="answerid"
                  :maxDerogations="maxDerogations"
                  :doneDerogations="doneDerogations"
                  :path="`${currentQuestion.path ? currentQuestion.path + '|' : $route.params.sequenceid + '|'}${questionid}`"
                  :input="input"
                  :disabledInputs="disabledInputs"
                  @inputUpdated="inputChange"
                  class="px-4"
                ></Inputs>
              </v-flex>
            </template>
              
          </v-layout>
        </template>
        <template v-else>
          <v-layout
            d-block
            d-md-flex
            row
            ma-0
            align-center
            justify-space-between
            xs12
            lg10
            offset-lg2
          >
            Sorry there is no question found
          </v-layout>
        </template>
      </div>
    </div>

    <div class="box mt-4">
      <AskBox
        :question="questionid"
        :keywordid="$route.params.sequenceid"></AskBox>
    </div>

    <!-- Navigation buttons -->
    <div class="overflow-hidden mt-8">

       <v-btn
        v-if="prev"
        outlined
        rounded
        color="primary"
        class="float-left"
        @click="prevQuest"
        :disabled="!prev"
      >
        {{ $t("survey-question-block.btn-1") }}
      </v-btn>
      <!-- <pre>{{currentQuestion}}</pre> -->
      <v-btn
        v-if="next"
        outlined
        rounded
        color="primary"
        class="float-right"
        @click="nextQuest"
        :disabled="!next"
      >
        {{ $t("survey-question-block.btn-2") }}
      </v-btn>
      <!-- <pre>{{currentQuestion}}</pre> -->
      <!-- <button v-else @click="test">test</button>
      <pre v-if="testvar">{{testvar}}</pre> -->
    </div>
    <!-- <pre>{{currentQuestion}}</pre> -->
  </div>
</template>

<script>
import { showUQuestion } from '@/js/survey/showUQuestion'
import { showQuestion } from '@/js/survey/showQuestion'
import Inputs from '@/components/audits/survey/Inputs'
import Inspector from '@/components/audits/survey/inputs/Inspector'
import InspectorNote from '@/components/audits/survey/InspectorNote'
import AskBox from '@/components/audits/survey/AskBox'
import HTTPresponse from '@/components/app/HTTPresponse'

export default {
  props: {
    question: Object,
    questionid: String,
    answerid: String,
    maxDerogations: Number,
    doneDerogations: Number,
    disabledInputs: {
      type: Boolean,
      default: false
    },
    noButton: Boolean,
    // inspector: {
    //   type: Boolean,
    //   default: () => false
    // }
  },

  components: {
    Inputs: Inputs,
    // Inspector: Inspector,
    // InspectorNote: InspectorNote,
    AskBox: AskBox,
    HTTPresponse: HTTPresponse
  },

  data () {
    return {
      currentQuestion: null,
      // inspectorNote: false,
      next: null,
      prev: null,
      httpalert: false
      // renderComponent: true
    }
  },

  async created () {
    await this.rendreQuestion()
    // if (this.question) this.currentQuestion = this.question;
  },

  methods: {
    // changeTabVal (value) {
    //   this.$emit('tabChnage', value, true)
    // },
    inputChange () {
      this.rendreQuestion()
      this.$emit('updateSubmitBtn')
      // this.$emit('updateSeq')
    },
    async rendreQuestion () {
      const params = {
        questionid: this.questionid,
        answerid: this.$route.params.answerid,
        key: this.$store.state.auth.token
      }
      await showUQuestion(params)
        .then(response => {
          this.currentQuestion = response;
          if (this.currentQuestion.next.id) this.next = this.currentQuestion.next.id;
          if (this.currentQuestion.prev.id) this.prev = this.currentQuestion.prev.id;
          console.log(this.currentQuestion);
        })
    },

    nextQuest() {
      this.$emit('changeQuest', this.next);
      // this.$router.replace({ name: 'edit-audit-unanswered', params: { questionid: this.currentQuestion.next.id } });
    },
    prevQuest() {
      this.$emit('changeQuest', this.prev);
      // this.$router.replace({ name: 'edit-audit-unanswered', params: { questionid: this.currentQuestion.prev.id } });
    },

    HTTPState (value) {
      this.httpalert = this.value
    }
  },

  mounted () {
    this.$root.$on('disableInterceptor')
  },

  computed: {
    rebuildInputs () {
      var inputs = []
      let backgroundColor = '#FFFFFF'
      let padding = false

      this.currentQuestion.modules.forEach(async input => {
        const type = input.type

        // check if type is radio or pulldown
        if (type.indexOf('radio') > -1 || type.indexOf('pulldown') > -1) {
          const exist = type in inputs
          if (exist === false) { // if key doesn't exist in table create it then push input
            inputs.push(inputs[type] = [])

            input.bg = backgroundColor
            if (padding) input.padding = padding

            inputs[type].push(input)

            if (input.continued !== 'yes') {
              padding = false
              backgroundColor = backgroundColor === '#FFFFFF' ? 'rgba(243, 244, 249, 0.4)' : '#FFFFFF'
            } else { padding = true }
          } // else if key exist just push in input
          else {
            inputs[type].push(input)
          }
        } else {
          input.bg = backgroundColor
          if (padding) input.padding = padding

          inputs.push(input)

          if (input.continued !== 'yes') {
            padding = false
            backgroundColor = backgroundColor === '#FFFFFF' ? 'rgba(243, 244, 249, 0.4)' : '#FFFFFF'
          } else { padding = true }
        }
      })
      return inputs
    }
  }
}
</script>
